import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {toAiCampaignMiniBrief} from '../../../copilotCampaigns.dataConverters';
import {CampaignToolName} from '../../../copilotCampaigns.enums';
import campaignsApi from 'common/src/modules/campaigns/campaigns.api';

const inputSchema = z.object({
  campaignId: z.number().describe('The campaign ID of the brief'),
  versionNumber: z.number().describe('The version of the campaign of the brief'),
});

function getBriefTool() {
  async function execute({
    input: {campaignId, versionNumber},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const {brief} = await campaignsApi.getMiniBrief(campaignId, versionNumber);
    const aiMiniBrief = toAiCampaignMiniBrief(brief);

    return toolResult(JSON.stringify(aiMiniBrief));
  }

  return tool({
    name: CampaignToolName.GetBrief,
    displayName: 'Reading brief',
    description: 'get campaign brief',
    execute,
    inputSchema,
    isReadonly: true,
  });
}

export default getBriefTool;
